import { Order } from "@infrastructure/Services/PostService.types";
import { SortItemType } from "../Components/SortingChips/SortingChips.types";

export const SORT_CRITERIA_LIST: Array<SortItemType> = [
    {
        label: "Neueste",
        criterion: {
            limit: 10,
            "orderBy[field]": "createdAt",
            "orderBy[direction]": "DESC" as Order,
        },
    },
    {
        label: "Im Trend",
        criterion: {
            limit: 10,
            "orderBy[field]": "popularity",
            "orderBy[direction]": "DESC" as Order,
        },
    },
];
